const GenerateQuote = () => {
  return <div>Generate Quote page placeholder</div>;
};

export { GenerateQuote };
